/**
 * @fileoverview GET handler for the "/admin/get_impersonation_logs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { adminGetImpersonationLogs } from "./constants";
import type { AdminGetImpersonationLogsResult } from "./types";

export const getAdminGetImpersonationLogs = reactQueryFetcherAdapter(
  adminGetImpersonationLogs,
  (signal: AbortSignal): Promise<AdminGetImpersonationLogsResult> => {
    return fetch("/admin/get_impersonation_logs", "GET", {}, { signal });
  }
);
